angular.module 'zc.master.reports'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master.reports',
    url: '/reports'
    views:
      'content@':
        templateUrl: '/templates/master.reports/list.html'
        controller: 'MasterReportsCtrl'
        resolve:
          projects: (MasterProject) ->
            MasterProject.all()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.reports/routes.js.coffee